import React, { useState, useEffect } from 'react';
import Table, { TableRow, TableCell } from "@amzn/meridian/table"

const TableRows = ["Total Actions Taken", "% of Total Results"]
const CaseFinalTable = ({ caseQuestionData }) => {

    // Backend flags trainer answers by id (handles multi-select and duplicate labels);
    // fall back to label matching for older API responses.
    const isTrainerAnswer = (a) => a.isTrainerAnswer ?? a.answerLabel === caseQuestionData.trainerFinalAction

    return (
        <Table key='case-final-table' headerRows={1} spacing="small" showDividers nestedRows rowComponents={[TableRow]}>
            <TableRow key='case-final-table-header'>
                <TableCell>
                    {/* Empty Cell for 1st Column */}
                </TableCell>
                {caseQuestionData.finalAction &&
                    caseQuestionData.finalAction.map((header) => {
                        const headerColor = isTrainerAnswer(header) ? "LightGreen" : "primary"
                        return (
                            <TableCell  backgroundColor={headerColor} >
                                {header.answerLabel}
                            </TableCell>
                        )
                    })
                }
            </TableRow>
            {caseQuestionData.finalAction &&
                TableRows.map((q, ind) => {
                    return (
                        <TableRow key={q}>
                            <TableCell>
                                {q}
                            </TableCell>
                            {
                                caseQuestionData.finalAction.map((a) => {
                                    const cellColor = isTrainerAnswer(a) ? "LightGreen" : "primary"

                                    if (ind !== TableRows.length - 1) {
                                        return (
                                            <TableCell backgroundColor={cellColor}>
                                                {a.tally}
                                            </TableCell>
                                        )
                                    } else {
                                        return (
                                            <TableCell backgroundColor={cellColor}>
                                                {(a.tally / caseQuestionData.totalResponses * 100).toFixed(2)}%
                                            </TableCell>
                                        )
                                    }
                                })
                            }
                        </TableRow>
                    )
                })
            }
        </Table>
    )
}

export default CaseFinalTable